export default __webpack_public_path__ + "static/media/1.3c4e9281.mp4";